'use client';
import { PropsWithChildren } from 'react';
import { useFullMenu } from './use-full-menu';
import { cn } from '@lib/utils';

const MobileFullMenuWrapper = ({ children }: PropsWithChildren) => {
  const { isOpen } = useFullMenu();

  return (
    <div
      className={cn(
        'sitemap_wrapper_m fixed -top-0 bottom-0 left-0 z-[20000] h-screen w-full overflow-y-auto bg-[#040435] px-[20px] py-[25px] lg:hidden',
        isOpen ? 'block' : 'hidden',
      )}
    >
      <div className="scrollEnable relative z-[999999] block">{children}</div>
    </div>
  );
};
export default MobileFullMenuWrapper;
